// ==============================|| OVERRIDES - TABLE PAGINATION ||============================== //

export default function TablePagination(theme) {
    return {
        MuiTablePagination: {
            styleOverrides: {
                root: {
                    color: theme.palette.text.main,
                },
                selectLabel: {
                    // fontSize: '0.875rem'
                },
                displayedRows: {
                    // fontSize: '0.875rem'
                }
            }
        }
    };
}
